import QuickDonate from "components/QuickDonate/QuickDonate";
import { useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import ScrollToTop from "components/ScrollToTop";
import Header from "components/Header";
import Footer from "components/Footer";
import Hero from "./Sections/Hero";
import RecentProjects from "./Sections/RecentProjects";
import SpeechOfTheCEO from "./Sections/SpeechOfTheCEO";
import LatestNews from "./Sections/LatestNews";
import SuccessPartners from "./Sections/SuccessPartners";

const Home = () => {
  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  return (
    <div className="w-full relative">
      <Header />

      <main className="relative w-full">
        {/* scroll to top  ******************************/}
        <ScrollToTop />

        {/* quick donate ******************************/}
        <QuickDonate />

        {/* quick donate popup  ******************************/}
        {quickDonateStatus && <QuickDonatePopUp />}

        {/* hero section  ******************************/}
        <Hero />

        {/* our recent projects ******************************/}
        <RecentProjects />

        {/* The Speech of The CEO ******************************/}
        <SpeechOfTheCEO />

        {/* latest news ******************************/}
        <LatestNews />

        {/* Success partners ******************************/}
        <SuccessPartners />
      </main>

      <Footer />
    </div>
  );
};

export default Home;
